import { Component } from '@angular/core';

@Component({
  selector: 'home-ride-share',
  standalone: false,
  templateUrl: './ride-share.component.html',
  styleUrl: './ride-share.component.css'
})
export class RideShareComponent {

}
